import { Trans } from 'react-i18next';

import { Alert } from 'components/Blocks';

import { useLang } from 'hooks';

import { OTHER_CHAR_LIMIT } from './utils';

interface OtherAdviseProps {
  other: string;
}

const REF_PERCENTAGE = 0.5;

export function OtherAdvise({ other }: OtherAdviseProps) {
  const { t } = useLang();

  const show = OTHER_CHAR_LIMIT * REF_PERCENTAGE <= other?.length;

  if (!show) return null;

  return (
    <Alert level="info" title={t('other-size-title')}>
      <Trans i18nKey="other-size-description" />
    </Alert>
  );
}
